export default __webpack_public_path__ + "static/media/gas-LP.f5b67a65.svg";